import React from 'react';
import { Mail } from 'react-feather';
import { style } from '../../api';
import { Button } from '../../VuexyDesign/atoms/_index';

function PricingCardButtonUpdated({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  plan,
  width,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type,
}: PricingCardButtonUpdatedProps) {
  return (
    <div className="d-flex flex-column align-items-center w-100">
      <p
        className="text-center font-weight-bold mb-1"
        style={{ color: style.primary_pink_new, fontSize: '14px' }}
      >
        Temporarily not accepting new subscriptions
      </p>
      <a href="mailto:hello@virpp.com" style={{ textDecoration: 'none' }}>
        <Button
          color="dark"
          outline
          className={`br-5 ${
            width || ''
          } d-flex align-items-center justify-content-center`}
          style={{ gap: '0.5rem' }}
        >
          <Mail size={16} />
          <span>Contact Sales</span>
        </Button>
      </a>
    </div>
  );
}

const Wrapper = (props: PricingCardButtonUpdatedProps) => (
  <PricingCardButtonUpdated {...props} />
);
export default Wrapper;

interface PricingCardButtonUpdatedProps {
  plan: {
    title: string;
    newTitle: string;
    subtitle: string;
    includes: string;
    image: string;
    symbolCurrency?: string;
    monthlyPriceCurrency?: string;
    yearlyPriceCurrency?: string;
    monthlyPrice?: string;
    yearlyPrice?: string;
    benefits: {
      text: string;
      overline: boolean;
    }[];
    popular: boolean;
    pro: boolean;
    amateur?: boolean;
    yearly_plan_id?: string;
    monthly_plan_id?: string;
  };
  type?: string | undefined;
  width?: string;
}
